import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../../ui/app-dc.icons';

type AvailableAction = 'DELETE_PROFILE' | 'UPDATE_PROFILE';

export interface IProfileActionConfirmationModalData {
	id: string | Array<string>;
	element: string;
	action: AvailableAction;
}

@Component({
	selector: 'app-profile-action-confirm-popup',
	templateUrl: './profile-action-confirm-popup.component.html',
	styleUrls: ['./profile-action-confirm-popup.component.scss'],
})
export class ProfileActionConfirmPopupComponent<
	T extends IProfileActionConfirmationModalData
> extends DcBaseComponent {
	protected readonly DcIcons = DcIcons;

	public vo$: Observable<{
		element: string;
		elementId: string | Array<string>;
		action: AvailableAction;
		isMultipleElement: boolean;
	}>;
	public confirm = false;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'profile-action-confirm-popup';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement: Array.isArray(this.modalData.id),
			elementId: this.modalData.id,
			action: this.modalData.action,
		});
	}

	public launchAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
